import PageHeader from './PageHeader'
export type { PageHeaderProps } from './PageHeader'
export default PageHeader
